/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum SystemEventStatus {
  initialStatus = "initialStatus",
  finalStatus = "finalStatus",
  errorStatus = "errorStatus",
  gettingMLData = "gettingMLData",
  updatingESNN = "updatingESNN",
  reindexingCandidates = "reindexingCandidates",
}

export const SystemEventStatusDisplay: Record<SystemEventStatus, string> = {
  [SystemEventStatus.initialStatus]: "Initial Status",
  [SystemEventStatus.finalStatus]: "Final Status",
  [SystemEventStatus.errorStatus]: "Error Status",
  [SystemEventStatus.gettingMLData]: "Getting ML Data",
  [SystemEventStatus.updatingESNN]: "Updating ESNN",
  [SystemEventStatus.reindexingCandidates]: "Reindexing Candidates",
};
